import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { CheckCircle2Icon, TrendingUpIcon, ZapIcon } from 'lucide-react';
export function TrustScoreSection() {
  const points = ['Behavioral Analytics', 'Transaction Pattern Analysis', 'Explainable AI Decisions', 'Regulatory Compliant'];
  return <section className="py-24 bg-slate border-y border-white/5 overflow-hidden" data-id="element-636">
      <div className="max-w-7xl mx-auto px-6" data-id="element-637">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-638">
          {/* Content */}
          <div data-id="element-639">
            <FadeIn data-id="element-640">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue/10 border border-blue/20 text-blue text-sm font-medium mb-6" data-id="element-641">
                Proprietary Technology
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-642">
                The FIQIS Trust Score
              </h2>
              <p className="text-xl text-gray-400 mb-8" data-id="element-643">
                A proprietary, explainable scoring model that drives smarter
                lending decisions within your institutional boundaries. Move
                beyond traditional credit scores.
              </p>
            </FadeIn>

            <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-644">
              {points.map((point, i) => <StaggerItem key={i} className="flex items-center gap-3" data-id="element-645">
                  <CheckCircle2Icon className="w-5 h-5 text-teal flex-shrink-0" data-id="element-646" />
                  <span className="text-gray-300 font-medium" data-id="element-647">{point}</span>
                </StaggerItem>)}
            </StaggerContainer>

            <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-6 p-6 bg-navy rounded-xl border border-white/5" data-id="element-648">
              <div className="flex-1" data-id="element-649">
                <div className="flex items-center gap-2 text-teal mb-2" data-id="element-650">
                  <TrendingUpIcon className="w-5 h-5" data-id="element-651" />
                  <span className="font-bold text-2xl" data-id="element-652">Up to 40%</span>
                </div>
                <p className="text-sm text-gray-400" data-id="element-653">
                  Increase in micro-lending approval rates
                </p>
              </div>
              <div className="w-px bg-white/10 hidden sm:block" data-id="element-654"></div>
              <div className="flex-1" data-id="element-655">
                <div className="flex items-center gap-2 text-blue mb-2" data-id="element-656">
                  <ZapIcon className="w-5 h-5" data-id="element-657" />
                  <span className="font-bold text-2xl" data-id="element-658">3x Faster</span>
                </div>
                <p className="text-sm text-gray-400" data-id="element-659">
                  Credit decisioning process
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Visual Gauge */}
          <FadeIn direction="left" delay={0.2} className="relative flex justify-center items-center" data-id="element-660">
            <div className="relative w-full max-w-md aspect-square flex items-center justify-center" data-id="element-661">
              {/* Decorative background circles */}
              <div className="absolute inset-0 rounded-full border border-white/5 scale-110" data-id="element-662"></div>
              <div className="absolute inset-0 rounded-full border border-white/5 scale-90" data-id="element-663"></div>

              {/* SVG Gauge */}
              <svg viewBox="0 0 200 200" className="w-full h-full transform -rotate-90 drop-shadow-[0_0_15px_rgba(0,212,170,0.3)]" data-id="element-664">
                {/* Background track */}
                <circle cx="100" cy="100" r="80" fill="none" stroke="#111D35" strokeWidth="12" strokeLinecap="round" data-id="element-665" />
                {/* Progress track */}
                <circle cx="100" cy="100" r="80" fill="none" stroke="url(#tealGradient)" strokeWidth="12" strokeLinecap="round" strokeDasharray="502" strokeDashoffset="120" className="animate-[pulse-slow_3s_ease-in-out_infinite]" data-id="element-666" />
                <defs data-id="element-667">
                  <linearGradient id="tealGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-668">
                    <stop offset="0%" stopColor="#3B82F6" data-id="element-669" />
                    <stop offset="100%" stopColor="#00D4AA" data-id="element-670" />
                  </linearGradient>
                </defs>
              </svg>

              {/* Center Content */}
              <div className="absolute flex flex-col items-center justify-center text-center" data-id="element-671">
                <span className="text-gray-400 text-sm font-medium uppercase tracking-widest mb-1" data-id="element-672">
                  Trust Score
                </span>
                <span className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-white to-gray-400" data-id="element-673">
                  842
                </span>
                <span className="text-teal text-sm font-semibold mt-2 bg-teal/10 px-3 py-1 rounded-full" data-id="element-674">
                  Excellent
                </span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}